import VueLoader from '../../default/vue-loader'
import { store } from'../../default/store'

import ReservationsHistory from './reservations_history_index'

document.addEventListener('turbo:load', () => {
  VueLoader.loadVueComponent(ReservationsHistory, document.getElementById('hotelReservationsHistory'), store)
})

